import React, { useReducer, useContext, useRef } from "react";
import PrimeReact from "primereact/api";

import GlobalContext from "../../isp._comun/iu/contexto/GlobalContext";
import CrearHandlerDeErroresComunesDeComando from "../../isp._comun/iu/componentes/CrearHandlerDeErroresComunesDeComando";

import VentanaCliente from "../../isp.iu.clientes/reductores/ventanas/VentanaCliente";
import VentanaQueryClientes from "../../isp.iu.clientes/reductores/ventanas/VentanaQueryClientes";
import VentanaSeleccionarCliente from "../../isp.iu.clientes/reductores/ventanas/VentanaSeleccionarCliente";
import VentanaItem from "../../isp.iu.items/reductores/ventanas/VentanaItem";
import VentanaQueryItems from "../../isp.iu.items/reductores/ventanas/VentanaQueryItems";
import VentanaServicio from "../../isp.iu.servicios/reductores/ventanas/VentanaServicio";
import VentanaQueryServicios from "../../isp.iu.servicios/reductores/ventanas/VentanaQueryServicios";
import VentanaContrato from "../../isp.iu.contratos/reductores/ventanas/VentanaContrato";
import VentanaQueryContratos from "../../isp.iu.contratos/reductores/ventanas/VentanaQueryContratos";
import VentanaPlan from "../../isp.iu.planes/reductores/ventanas/VentanaPlan";
import VentanaQueryPlanes from "../../isp.iu.planes/reductores/ventanas/VentanaQueryPlanes";
import VentanaZona from "../../isp.iu.zonas/reductores/ventanas/VentanaZona";

import DialogoCliente from "../../isp.iu.clientes/componentes/DialogoCliente";
import DialogoQueryClientes from "../../isp.iu.clientes/componentes/DialogoQueryClientes";
import DialogoSeleccionarCliente from "../../isp.iu.clientes/componentes/DialogoSeleccionarCliente";
import DialogoItem from "../../isp.iu.items/componentes/DialogoItem";
import DialogoQueryItems from "../../isp.iu.items/componentes/DialogoQueryItems";
import DialogoServicio from "../../isp.iu.servicios/componentes/DialogoServicio";
import DialogoQueryServicios from "../../isp.iu.servicios/componentes/DialogoQueryServicios";
import DialogoContrato from "../../isp.iu.contratos/componentes/DialogoContrato";
import DialogoQueryContratos from "../../isp.iu.contratos/componentes/DialogoQueryContratos";

import PrincipalReducer from "../reductores/PrincipalReducer";
import PantallaPrincipalLayout from "./layouts/PantallaPrincipalLayout";

import EliminarVentana from "../reductores/acciones/widgets/EliminarVentana";
import PosicionarVentanaTop from "../reductores/acciones/widgets/PosicionarVentanaTop";
import CrearYMostrarVentana from "../reductores/acciones/widgets/CrearYMostrarVentana";
import DialogoPlan from "../../isp.iu.planes/componentes/DialogoPlan";
import DialogoQueryPlanes from "../../isp.iu.planes/componentes/DialogoQueryPlanes";
import VentanaQueryZonas from "../../isp.iu.zonas/reductores/ventanas/VentanaQueryZonas";
import DialogoZona from "../../isp.iu.zonas/componentes/DialogoZona";
import DialogoQueryZonas from "../../isp.iu.zonas/componentes/DialogoQueryZonas";
import VentanaAsociado from "../../isp.iu.asociados/reductores/ventanas/VentanaAsociado";
import VentanaQueryAsociados from "../../isp.iu.asociados/reductores/ventanas/VentanaQueryAsociados";
import DialogoAsociado from "../../isp.iu.asociados/componentes/DialogoAsociado";
import DialogoQueryAsociados from "../../isp.iu.asociados/componentes/DialogoQueryAsociados";
// import { v4 } from "uuid";

// import ClienteAFacturar from "../../entidades/ClienteAFacturar";
// import DataDeRespuestas_Facturacion from "../../servicios/DataEstaticaDeRespuestas.json";

const PantallaPrincipal = () => {
    const initialState = {
        ventanas: [],
        // banderaDeNotificacionEventos:true
        banderaCerrandoSesion: false,
    };

    const [state, dispatchPrincipal] = useReducer(PrincipalReducer, initialState);

    // PrimeReact.autoZIndex = false;
    PrimeReact.autoZIndex = true;

    PrimeReact.zIndex = {
        modal: 1100, // dialog, sidebar
        overlay: 1000, // dropdown, overlaypanel
        menu: 1000, // overlay menus
        tooltip: 1100, // tooltip
        toast: 1200, // toast
    };

    const componentesReact = state.ventanas.map((ventana) => {

        if (ventana instanceof VentanaCliente) {
            return <DialogoCliente key={ventana.id} ventana={ventana} />;
        }

        // if (ventana.tipo === DialogType.QUERY_CLIENTES_A_FACTURAR) {
        if (ventana instanceof VentanaQueryClientes) {
            return <DialogoQueryClientes key={ventana.id} ventana={ventana} />;
        }
        
        if (ventana instanceof VentanaSeleccionarCliente) {
            return <DialogoSeleccionarCliente key={ventana.id} ventana={ventana} />;
        }

        if (ventana instanceof VentanaAsociado) {
            return <DialogoAsociado key={ventana.id} ventana={ventana} />;
        }

        // if (ventana.tipo === DialogType.QUERY_CLIENTES_A_FACTURAR) {
        if (ventana instanceof VentanaQueryAsociados) {
            return <DialogoQueryAsociados key={ventana.id} ventana={ventana} />;
        }

        if (ventana instanceof VentanaItem) {
            return <DialogoItem key={ventana.id} ventana={ventana} />;
        }

        if (ventana instanceof VentanaQueryItems) {
            return <DialogoQueryItems key={ventana.id} ventana={ventana} />;
        }

        if (ventana instanceof VentanaPlan) {
            return <DialogoPlan key={ventana.id} ventana={ventana} />;
        }

        if (ventana instanceof VentanaQueryPlanes) {
            return <DialogoQueryPlanes key={ventana.id} ventana={ventana} />;
        }

        if (ventana instanceof VentanaServicio) {
            return <DialogoServicio key={ventana.id} ventana={ventana} />;
        }
        if (ventana instanceof VentanaQueryServicios) {
            return <DialogoQueryServicios key={ventana.id} ventana={ventana} />;
        }

        if (ventana instanceof VentanaContrato) {
            return <DialogoContrato key={ventana.id} ventana={ventana} />;
        }
        if (ventana instanceof VentanaQueryContratos) {
            return <DialogoQueryContratos key={ventana.id} ventana={ventana} />;
        }
        if (ventana instanceof VentanaZona) {
            return <DialogoZona key={ventana.id} ventana={ventana} />;
        }
        if (ventana instanceof VentanaQueryZonas) {
            return <DialogoQueryZonas key={ventana.id} ventana={ventana} />;
        }
        return null;
    });

    const refPantallaPrincipalLayout = useRef(null);

    const notificar = function (notificacionToast) {
        refPantallaPrincipalLayout.current.notificar(notificacionToast);
    };

    const values = useContext(GlobalContext);

    const handleErroresComunesDeComando = CrearHandlerDeErroresComunesDeComando(notificar);

    const handleErroresExtraEnPrincipal = (error) => {
        try {
            handleErroresComunesDeComando(error);
        } catch (error) {
            values.handleErroresExtraEnApp(error);
        }
    };

    const posicionarVentanaTop = (ventana) => {
        dispatchPrincipal(new PosicionarVentanaTop(ventana));
    };

    const eliminarVentana = (ventana) => {
        dispatchPrincipal(new EliminarVentana(ventana));
    };

    const crearYMostrarVentana = (ventana) => {
        dispatchPrincipal(new CrearYMostrarVentana(ventana));
    };

    const abrirVentana = (ventanaAAbrir) => {
        // const ventanaAAbrir = this.payload;

        const ventanaReemplazante = getVentanaIdenticaSiYaExisteEnLalista(ventanaAAbrir);
        if (ventanaReemplazante) {
            dispatchPrincipal(new PosicionarVentanaTop(ventanaReemplazante));
            // return action.ejecutar(state, nuevoEstado);
        } else {
            dispatchPrincipal(new CrearYMostrarVentana(ventanaAAbrir));
            // const action = new CargarYMostrarVentana(ventanaAAbrir);
            // return action.ejecutar(state, nuevoEstado);
        }
    };

    const abrirVentanaSeleccionarCliente = (notificarClienteSeleccionado) => {
        const ventanaAAbrir = new VentanaSeleccionarCliente(notificarClienteSeleccionado);

        const ventanaReemplazante = getVentanaIdenticaSiYaExisteEnLalista(ventanaAAbrir);
        if (ventanaReemplazante) {
            dispatchPrincipal(new PosicionarVentanaTop(ventanaReemplazante));
        } else {
            dispatchPrincipal(new CrearYMostrarVentana(ventanaAAbrir));
        }
    };

    const getVentanaIdenticaSiYaExisteEnLalista = (ventanaAAbrir) => {
        const ventanaReemplazante = state.ventanas.find((ventanaExistente) => {
            if (ventanaExistente.puedeHacersePasarPor(ventanaAAbrir)) {
                return true;
            } else {
                return false;
            }
        });
        if (!ventanaReemplazante) {
            return null;
        }
        return ventanaReemplazante;
        /* if (ventanaReemplazante) {
            return ventanaReemplazante;
        } else {
           return null;
        } */
    };

    values.componentesReact = componentesReact;
    values.dispatchPrincipal = dispatchPrincipal;
    values.posicionarVentanaTop = posicionarVentanaTop;
    values.eliminarVentana = eliminarVentana;
    values.crearYMostrarVentana = crearYMostrarVentana;
    values.abrirVentana = abrirVentana;
    values.abrirVentanaSeleccionarCliente= abrirVentanaSeleccionarCliente;
    values.getVentanaIdenticaSiYaExisteEnLalista = getVentanaIdenticaSiYaExisteEnLalista;
    values.notificar = notificar;
    values.handleErroresExtraEnPrincipal = handleErroresExtraEnPrincipal;
    values.estadoPrin = state;

    return <PantallaPrincipalLayout ref={refPantallaPrincipalLayout} />;
};

export default PantallaPrincipal;
